export default __webpack_public_path__ + "static/media/glass_book_orange.4a9856eb.jpg";